export default "__VITE_ASSET__CSxKMG82__"